import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';

import { ContextToolbarComponent } from './contexttoolbar/contexttoolbar.component';
import { ContextProjectComponent } from './contextproject/contextproject.component';
import { ContextModalComponent } from './contextmodal/contextmodal.component';

@NgModule({
  declarations: [
    ContextToolbarComponent,
    ContextProjectComponent,
    ContextModalComponent
  ],
  exports: [
    ContextToolbarComponent,
    ContextProjectComponent,
    ContextModalComponent
  ],
  imports: [
    CommonModule,
    PoModule,
  ]
})

export class ContextModule {}
